<template>
    <div class="modal-auto-text modal-control-user-profile">
        <div class="head flex-row flex-between items-start">
            <div class="title" v-html="'유저 액션'" />
        </div>
        <div class="top" />
        <div class="">
            <!-- introducing day 수정 -->
            <div class="days-wrapper">
                <IntroDay
                    class="m-r-4"
                    v-for="idx in [1, 2, 3, 4, 5, 6, 7]"
                    :key="idx"
                    :introducingDay="idx"
                    :selected="idx === introducingDay || idx === introducingDay - 7"
                    :canClick="true"
                    @clickDay="changeIntroDay(idx)"
                    v-show="startDate"
                />
                <div
                    class="week-text"
                    v-show="user.introducing_day"
                    v-html="
                        user.introducing_day - weekdays > 0 && user.introducing_day - weekdays < 8
                            ? ' : 전달하는 주'
                            : ' : 쉬는 주'
                    "
                />
            </div>

            <!-- 심사보이기 / 만남 피드백 -->
            <div v-if="hideMemo !== true" class="flex-row m-b-8">
                <div class="btn user-detail-btn m-r-8" v-html="'심사 보이기'" @click="openUserProfileUpdateRequest" />
                <div
                    v-if="!isJudgeManager"
                    class="btn manner-feedback-btn"
                    v-html="'만남 피드백'"
                    @click="openMannerFeedback"
                />
            </div>

            <!-- 프로덕트 추가히기 -->
            <UserProducts :user="user" :reloadUser="options.reloadUser" />
        </div>
        <div class="buttons bottom">
            <div class="flex-row">
                <button @click="$emit('close', 0)" class="btn-default" v-html="'닫기'" />
                <!-- <button
                    ref="confirm"
                    @click="onConfirm"
                    :class="'btn-primary'"
                    v-html="'확인'"
                /> -->
            </div>
        </div>
    </div>
</template>
<script>
import userService from '@/services/user'
import UserProducts from '@/components/common/UserProducts'

export default {
    name: 'ModalControlUserProfile',
    props: ['options'],
    // props: [
    //     'user',
    //     'hideMemo',
    // ],
    components: {
        UserProducts,
    },
    data: () => ({
        date: '',

        showPUR: true,
    }),
    computed: {
        user() {
            return this.options.user
        },
        hideMemo() {
            return this.options.hideMemo
        },
        weekdays() {
            return this.$store.getters.weekdays
        },
        startDate() {
            return this.$store.getters.chat.user.service_start_date || true
        },
        introducingDay() {
            return this.$store.getters.chat.user.introducing_day
        },

        isJudgeManager() {
            return this.$store.getters.agent.id === 8
        },
    },
    watch: {
        user: function (val) {
            console.log('modal user: ', val)
            this.date = ''
        },
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            console.log('user', this.user)
            console.log('hideMemo', this.hideMemo)
        },

        onConfirm() {
            // this.update()
        },

        async changeIntroDay(day) {
            const res = await userService.updateIntroducingDay(this.user.id, { day: day })
            this.$set(this.user, 'introducing_day', res.day)
            this.$set(this.$store.getters.chat.user, 'introducing_day', res.day)
        },
        async inputIntroDay() {
            if (!this.date) return

            try {
                const res = await userService.updateIntroducingDay(this.user.id, { date: `20${this.date}` })
                const { introducing_day, service_start_date, products } = await userService.detail(this.user.id)
                this.$set(this.$store.getters.chatUser, 'introducing_day', introducing_day)
                this.$set(this.$store.getters.chatUser, 'service_start_date', service_start_date)
                this.$set(this.$store.getters.chatUser, 'products', products)
                this.date = ''
                this.$toast.success(`${res.msg} : ${res.day}`)
            } catch (e) {
                // console.log(e)
            }
        },

        openUserProfileUpdateRequest() {
            this.showPUR = !this.showPUR
        },
        openMannerFeedback() {
            this.$store.commit('setMannerFeedbackOpen', !this.isMannerFeedbackOpen)
        },
    },
}
</script>

<style scoped lang="scss">
.modal-control-user-profile {
    // display: flex;
    // align-items: center;
    // margin-bottom: 20px;

    .days-wrapper {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .week-text {
            @include f-bold;
            width: fit-content;
        }
        .date-text {
            margin-left: 8px;
            max-width: 100px;
        }
        .submit-btn {
            border-radius: 8px;
            // height: 23px;
            color: white;
            border: none;
            background-color: #8a74ff;
        }
    }

    .user-detail-btn {
        width: 100%;
        height: 40px;
        background-color: #8a74ff;
        color: white;
        font-size: 12px;
        border-radius: 8px;
        cursor: pointer;
        border-color: transparent !important;
    }
    .manner-feedback-btn {
        @extend .user-detail-btn;
        background-color: #ff3d6b;
    }
}
</style>
